<div id="upload-image-mobile">

  <div>
    <kl-task-full-view (taskDeleted)="ok()" [taskId]="taskId" ></kl-task-full-view>
  </div>

</div>
